import styled from 'styled-components';
import { Paragraph, spacing } from '@cambridgeassessment/cambridge-ui';

export const EntryCardInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: ${spacing.small};
`;

export const StyledComponentContainer = styled(Paragraph)`
  text-transform: capitalize;
  margin: ${spacing.base} 0;
`;
